import SlideInLayout from "components/layouts/SlideInLayout";
import { StoreListForDelivery } from "components/store/StoreList";
import { useSelector } from "react-redux";
import { NotPersistAction } from "store/actions";

function DeliveryStoreList(props) {
  const { stores } = useSelector((state) => state?.brand);
  const { storeModal } = useSelector((state) => state.NotPersist);
  return (
    <>
      <SlideInLayout
        shouldCloseOnEsc="No"
        shouldCloseOnOverlayClick="No"
        open={storeModal}
        reduxAction={NotPersistAction.setModalClose()}
        container={{
          className: `py-2`,
        }}
      >
        <StoreListForDelivery
          updateTemporaryLocation={props.updateTemporaryLocation}
          page="home-page"
          stores={stores}
          header={false}
          headerLabel=""
          styleClasses={`h-full`}
        />
      </SlideInLayout>
    </>
  );
}

export default DeliveryStoreList;
